// src/Redux/filterSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedFilter: [], // Will hold "Stores" or "Regions"
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const { setSelectedFilter } = filterSlice.actions;
export default filterSlice.reducer;
